import * as React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

export const CheckCircleOutlineNegativeIcon = (props: SvgIconProps) => {
    const {
        viewBox = "0 0 24 25",
        ...rest
    } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest} >
            <path d="M16.2426 9.67113L14.8284 8.25692L12 11.0853L9.17157 8.25692L7.75736 9.67113L10.5858 12.4996L7.75736 15.328L9.17157 16.7422L12 13.9138L14.8284 16.7422L16.2426 15.328L13.4142 12.4996L16.2426 9.67113ZM19.0711 5.42849C15.1678 1.52526 8.83216 1.52526 4.92893 5.42849C1.0257 9.33172 1.0257 15.6674 4.92893 19.5706C8.83216 23.4739 15.1678 23.4739 19.0711 19.5706C22.9743 15.6674 22.9743 9.33172 19.0711 5.42849ZM6.34315 18.1564C3.22481 15.0381 3.22481 9.96104 6.34315 6.8427C9.46149 3.72436 14.5385 3.72436 17.6569 6.8427C20.7752 9.96104 20.7752 15.0381 17.6569 18.1564C14.5385 21.2748 9.46149 21.2748 6.34315 18.1564Z" fill="#FC5A5A"/>
        </SvgIcon>
    );
};
